module.exports = __webpack_public_path__ + "static/media/DE.58cdc5f4.png";